// extracted by mini-css-extract-plugin
module.exports = {"text":"text_button-module__text--3aVl_","content":"text_button-module__content--1OA8l"};